import { render, staticRenderFns } from "./InterphoneSlot.vue?vue&type=template&id=00e2a621"
import script from "./InterphoneSlot.vue?vue&type=script&lang=js"
export * from "./InterphoneSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports